// Script to control when a user scrolls

// --- Global State and Utility Function ---

// Initialize 'userHasScrolled' in sessionStorage.
sessionStorage.setItem('userHasScrolled', 'false')

// Declare handler variables at the top scope so they can be referenced later for removal.
let keyboardScrollHandler
let mouseWheelScrollHandler
let mousedownScrollHandler
let touchMoveHandler
let currentTouchMoveScrollListener = null // Specific to touchmove logic

/**
 * Central function to remove all scroll-related event listeners.
 * This is called once markUserAsScrolled() sets the flag to true.
 */
function removeScrollListeners() {
  // Remove keyboard listener
  window.removeEventListener('keydown', keyboardScrollHandler)
  // Remove mouse wheel listener
  window.removeEventListener('wheel', mouseWheelScrollHandler)
  // Remove mousedown (scrollbar) listener
  window.removeEventListener('mousedown', mousedownScrollHandler)
  // Remove touchmove listener
  window.removeEventListener('touchmove', touchMoveHandler)

  // Also ensure any pending currentTouchMoveScrollListener is removed
  if (currentTouchMoveScrollListener) {
    window.removeEventListener('scroll', currentTouchMoveScrollListener)
    currentTouchMoveScrollListener = null
  }
}

/**
 * Marks the user as "has scrolled" in sessionStorage.
 * If the state changes to 'true', it also removes all active scroll-related listeners.
 */
function markUserAsScoded() {
  // Only update if the user hasn't already been marked as "has scrolled"
  if (sessionStorage.getItem('userHasScrolled') !== 'true') {
    sessionStorage.setItem('userHasScrolled', 'true')

    // --- Remove all listeners once the goal is achieved ---
    // This ensures we stop listening for scroll events once 'userHasScrolled' is true.
    removeScrollListeners()
  }
}

// --- Event Listeners Definitions ---

// Scrolling by keyboard
keyboardScrollHandler = function (e) {
  if (sessionStorage.getItem('userHasScrolled') === 'true') {
    window.removeEventListener('keydown', keyboardScrollHandler)
    return
  }

  const scrollKeys = [
    'PageUp',
    'PageDown',
    ' ', // PageUp, PageDown, Spacebar
    'ArrowUp',
    'ArrowDown', // Up, Down arrows
  ]
  const isCtrlHome = e.ctrlKey && e.key === 'Home'
  const isCtrlEnd = e.ctrlKey && e.key === 'End'

  if (scrollKeys.includes(e.key) || isCtrlHome || isCtrlEnd) {
    markUserAsScoded()
  }
}

// Scrolling by mouse wheel
mouseWheelScrollHandler = function () {
  if (sessionStorage.getItem('userHasScrolled') === 'true') {
    window.removeEventListener('wheel', mouseWheelScrollHandler)
    return
  }
  markUserAsScoded()
}

// Scrolling by vertical scroll bar (mousedown on scrollbar)
mousedownScrollHandler = function (event) {
  if (sessionStorage.getItem('userHasScrolled') === 'true') {
    window.removeEventListener('mousedown', mousedownScrollHandler)
    return
  }

  // Detect if the click was on the vertical scrollbar.
  // This is a heuristic and might not be 100% accurate across all browsers/OS.
  // -17px is a typical scrollbar width.
  const isClickOnVerticalScrollbar =
    event.target === document.documentElement && event.clientX >= document.documentElement.offsetWidth - 17

  if (isClickOnVerticalScrollbar) {
    markUserAsScoded()
  }
}

// Mobile finger scroll (Optimized)
touchMoveHandler = function (event) {
  // If userHasScrolled is already true, this listener should be removed.
  // This check acts as a safeguard.
  if (sessionStorage.getItem('userHasScrolled') === 'true') {
    window.removeEventListener('touchmove', touchMoveHandler)
    // Also ensure any pending currentTouchMoveScrollListener is removed
    if (currentTouchMoveScrollListener) {
      window.removeEventListener('scroll', currentTouchMoveScrollListener)
      currentTouchMoveScrollListener = null
    }
    return
  }

  // If there's already an active scroll listener from a previous touchmove, remove it.
  // This prevents accumulation of listeners.
  if (currentTouchMoveScrollListener) {
    window.removeEventListener('scroll', currentTouchMoveScrollListener)
    currentTouchMoveScrollListener = null
  }

  // Define the new scroll listener for this touchmove.
  const newScrollListener = function () {
    markUserAsScoded()

    // This specific scroll listener removes itself once it fires.
    window.removeEventListener('scroll', newScrollListener)
    currentTouchMoveScrollListener = null
  }

  // Add the new scroll listener.
  window.addEventListener('scroll', newScrollListener)
  // Store the reference to the listener we just added.
  currentTouchMoveScrollListener = newScrollListener
}

// --- Initial Listener Attachments ---
// Attach all listeners initially. They will remove themselves once 'userHasScrolled' becomes true.
window.addEventListener('keydown', keyboardScrollHandler)
window.addEventListener('wheel', mouseWheelScrollHandler)
window.addEventListener('mousedown', mousedownScrollHandler)
window.addEventListener('touchmove', touchMoveHandler)

// --- Public API (assuming IB is a global object) ---

// Define IB if it doesn't exist, to prevent errors
if (typeof IB === 'undefined') {
  var IB = {}
}

/**
 * Resets the user's scroll state in sessionStorage to 'false'.
 * This will re-enable all scroll-related event listeners.
 */
IB.resetUserScrollListener = function () {
  sessionStorage.setItem('userHasScrolled', 'false')

  // Re-attach all listeners when the state is reset to 'false'
  // This ensures the detection mechanism is active again.
  window.addEventListener('keydown', keyboardScrollHandler)
  window.addEventListener('wheel', mouseWheelScrollHandler)
  window.addEventListener('mousedown', mousedownScrollHandler)
  window.addEventListener('touchmove', touchMoveHandler)
}

// --- Initial Check and Listener Setup ---
// On page load, if userHasScrolled is already true (e.g., from a previous page in the same session),
// ensure all listeners are immediately removed.
if (sessionStorage.getItem('userHasScrolled') === 'true') {
  removeScrollListeners()
}
